import React from "react";

function Error() {
  return <div>ERROR 404</div>;
}

export default Error;
